import * as yup from 'yup';

export const schema = yup.object().shape({
    referenceCode: yup
        .string()
        .required('Ingrese un código de referencia')
        .max(40, 'Máximo 40 caracteres'),
});
